/**
 * Modal shell — fixed overlay (rgba 16,24,40,0.42) + centered card.
 * Card: card bg, radius r4, shadow-lg, slideup anim. Overlay: fadein.
 * Backdrop click closes; clicks inside stop propagation.
 */
import React from 'react';
import { colors, radii, shadows } from '../theme';

type Props = {
  width: number;
  onClose?: () => void;
  zIndex?: number;
  maxHeightVh?: number;
  children: React.ReactNode;
};

export default function Modal({ width, onClose, zIndex = 70, maxHeightVh = 90, children }: Props) {
  return React.createElement(
    'div',
    {
      className: 't-anim-fadein',
      onClick: onClose,
      style: {
        position: 'fixed',
        inset: 0,
        background: colors.overlay,
        display: 'grid',
        placeItems: 'center',
        zIndex,
        padding: 24,
      } as React.CSSProperties,
    },
    React.createElement(
      'div',
      {
        className: 't-anim-slideup',
        onClick: (e: React.MouseEvent) => e.stopPropagation(),
        style: {
          background: colors.card,
          borderRadius: radii.r4,
          boxShadow: shadows.lg,
          width,
          maxWidth: '100%',
          maxHeight: `${maxHeightVh}vh`,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        } as React.CSSProperties,
      },
      children,
    ),
  );
}
